<template>
  <svg
    id="Layer_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style="enable-background:new 0 0 512 512;"
    xml:space="preserve">
    <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256" />
    <g>
      <path style="fill:#D80027;" d="M244.87,256H512c0-23.107-3.08-45.489-8.819-66.783H244.87V256z" />
      <path style="fill:#D80027;" d="M244.87,122.435h229.556c-15.671-25.572-35.706-48.175-59.069-66.783H244.87V122.435z" />
      <path
        style="fill:#D80027;"
        d="M256,512c60.249,0,115.626-20.824,159.357-55.652H96.643C140.374,491.176,195.751,512,256,512z" />
      <path
        style="fill:#D80027;"
        d="M37.574,389.565h436.852c12.581-20.528,22.337-42.969,28.755-66.783H8.819
        C15.236,346.596,24.993,369.037,37.574,389.565z" />
    </g>
    <path style="fill:#0052B4;" d="M256,256c0-141.384,0-158.052,0-256C114.616,0,0,114.616,0,256H256z" />
    <g>
      <path
        style="fill:#FFDA44;"
        d="M170.234,219.13c-34.962,0-63.304-28.343-63.304-63.304s28.343-63.304,63.304-63.304
        c10.901,0,21.158,2.757,30.113,7.609c-14.048-13.737-33.26-22.217-54.461-22.217c-43.029,0-77.913,34.883-77.913,77.913
        s34.884,77.913,77.913,77.913c21.201,0,40.413-8.48,54.461-22.217C191.392,216.373,181.136,219.13,170.234,219.13z" />
      <polygon
        style="fill:#FFDA44;"
        points="188.073,111.304 199.312,134.806 224.693,128.942 213.327,152.381 233.739,168.568
        208.325,174.297 208.396,200.348 188.073,184.05 167.749,200.348 167.819,174.297 142.405,168.568 162.817,152.381 151.45,128.942
        176.833,134.806" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Ms',
};
</script>

<style>
</style>
